import logger from "@insite/client-framework/Logger";
import { getDataLayer } from "@MasterBluePrint/Tracking/trackingHelper";

const productPromotionTracking = (SlideModel: any) => {
    try {
        const dataLayer = getDataLayer();
        let promotionImpressionsEvent = dataLayer.find((x: any) => x?.event === "promotionImpressions");

        if (!promotionImpressionsEvent) {
            promotionImpressionsEvent = {
                event: "promotionImpressions",
                ecommerce: {
                    promotions: [],
                },
            };
            dataLayer.push(promotionImpressionsEvent);
        }

        const promotionsArr = promotionImpressionsEvent.ecommerce.promotions;

        SlideModel.forEach((SlideModelData: any, indexNumb: any) => {
            const slideTitle = SlideModelData.fields.slideTitle;
            const existingPromotionIndex = promotionsArr.findIndex((p: any) => p.id === slideTitle);
            const data = {
                id: SlideModelData.fields.slideTitle,
                name: SlideModelData.fields.boxcontentheading,
                creative: SlideModelData.fields.boxcontentsubheading,
                position: existingPromotionIndex === -1 ? indexNumb + 1 : indexNumb + 2,
            };

            if (existingPromotionIndex === -1) {
                promotionsArr.push(data);
            } else {
                promotionsArr[existingPromotionIndex] = {...promotionsArr[existingPromotionIndex], ...data};
            }
        });
    } catch (err) {
        logger.debug(err);
    }
}

export default productPromotionTracking;